import React, { useEffect } from 'react';
import styles from './index.module.css';
import AboutUsImg from '../../../assets/images/brand/about us image@3x.png';
import AboutUsLottoImg from '../../../assets/images/brand/about us image lotto@3x.png';
import { useTranslation } from 'react-i18next';
import WebXPaySubscription from '../WebXPaySubscription/WebXPaySubscription';

const AboutUs = () => {

  const { t, i18n } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={`${styles.bgColor}`}>
      <div className={`main-container `}>
        <div className={`container-content`}>
          <div className={`card-section`}>
            <div className={`main-card`}>
              <div className={styles.subTopic}>{t(`About Us`)}</div>
              <div className={styles.bodyDiv}>
                <div className={styles.bodyParagph}>
                  <p>
                    <b>mylottery.lk </b> is the official digital lottery selling platform authorized by the National Lotteries Board (NLB) of Sri Lanka. Our platform is the latest innovative brand introduced by Koshara International PVT Ltd. As a trusted partner in national lottery innovation, we aim to modernize the traditional lottery experience by offering secure, transparent, and eco-friendly access to lottery products via the internet.
                    <br />
                    <br />
                    <p className={styles.subTopic} style={{ marginTop: '10px', marginBottom: '15px' }}>{t(`Vision`)}</p>
                    <p className={styles.subParagph}>
                      To foster a sustainable and inclusive Sri Lankan community by embracing eco-friendly practices and empowering individuals with equal winning opportunities to achieve their dreams.
                      {' '}
                    </p>
                    <p className={styles.subTopic} style={{ marginTop: '20px', marginBottom: '15px' }}>{t(`Mission`)}</p>
                    <p className={styles.subParagph}>
                      Using our cutting-edge digital technology to offer the Sri Lankan community a reliable and convenient way to purchase lottery tickets from the comfort of their homes, creating equal winning opportunities to turn dreams into achievements.
                    </p></p>
                </div>
                <img
                  src={AboutUsImg}
                  alt='AboutImg'
                  className={styles.aboutUsImg}
                />
              </div>
              <div className={styles.bottomDiv}>
                <img
                  src={AboutUsLottoImg}
                  alt='LottoImg'
                  className={styles.aboutUsLottoImg}
                />
                <div>
                  <div className={styles.subTopic}>
                    {i18n.language === 'si'? `අපව තෝරා ගත යුතු වන්නේ ඇයි` : i18n.language === 'ta'? `எங்களைத் தேர்வு செய்யுங்கள்` :`Why Choose Us?`}</div>
                  <br />
                  <p className={styles.subParagph}>
                    As we have official authorization from NLB, all your transactions within this website are completely secure.
                    <br />
                    <br />
                    We cater to our customers without any additional charge and within our platform users can purchase lotteries at the exact price of NLB printed lottery tickets.
                    <br />
                    <br />
                    For the first time in Sri Lanka, our platform brings you the opportunity to visually browse through available lottery tickets and pick your favorite letters, numbers and signs, providing the same experience as buying tickets from a ticket booth.
                    <br />
                    <br />
                    Chance to buy tickets 24/7, track results on the spot and receive winnings automatically to your digital wallet or bank account.
                    <br />
                    <br />
                    We are committed to promoting healthy lottery habits as our system includes spending limits, age verification, and self-exclusion tools.
                    <br />
                    <br />
                    We also take the initiative to promote eco-friendly lottery buying habits with the prevention of paper use.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
